module.exports = __webpack_public_path__ + "assets/3d69f11dca48c538dcc54d29d5eda0ec.mp4";